module.exports = __webpack_public_path__ + "static/media/wendy_cabrera_rubio_11.40b3eeea.jpg";